// extracted by css-extract-rspack-plugin
export default {"section":"YL3EjbqLAlUh5sw3","heading":"Ws5V0lY_r2smW3MC"};